import { render, staticRenderFns } from "./SigaInstanceList.vue?vue&type=template&id=4724df51"
import script from "./SigaInstanceList.vue?vue&type=script&lang=js"
export * from "./SigaInstanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports